import { IconType } from "~/common/components/icon/IconType";
import { NotificationsMenu } from "~/Header/components/Notifications/NotificationsMenu";
import { Permission, userHasPermission } from "~/utils/permissions";
import { useSimpleMenuState } from "~/common/components/Menu/Menu";
import { useSelector } from "react-redux";
import { selectNewNotificationAmount } from "~/Notifications/redux/NotificationsSelectors";
import { useTranslation } from "react-i18next";
import { PersonalNavItem } from "~/Header/components/headerMenu/PersonalNavItem";

export const NotificationNavItem = () => {
  const { t } = useTranslation();
  const [isOpenNotifications, handleClickNotifications, handleCloseNotifications, anchorElNotifications] =
    useSimpleMenuState();

  const newNotificationAmount = useSelector(selectNewNotificationAmount);

  if (!userHasPermission(Permission.SEE_NOTIFICATIONS)) {
    return null;
  }

  return (
    <li className="scha__personal-nav__list__item">
      <PersonalNavItem
        name={t("header.link.my.notification")}
        data-test-id={"header-btn-notification"}
        icon={IconType.Bell}
        badgeContent={newNotificationAmount}
        isActive={isOpenNotifications}
        onClick={handleClickNotifications}
        data-ta-spec={"bell-icon"}
        data-ta-total={newNotificationAmount}
        isNotification
      />
      <NotificationsMenu
        open={isOpenNotifications}
        anchorEl={anchorElNotifications}
        onClose={handleCloseNotifications}
      />
    </li>
  );
};
